

















































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class InfoAlert extends Vue {
  @(Prop(String)!) title!: string;
  @(Prop(String)!) description!: string;
  @Prop({ type: Boolean, default: false }) isTitleLineBreakEnabled!: boolean;
  @Prop(Number) maxCharacters?: number;

  readMoreEnabled = false;
  readonly MAX_CHARACTER_COUNT = 55;

  get descriptionMaxCharacterCount() {
    return this.maxCharacters
      ? this.maxCharacters
      : this.MAX_CHARACTER_COUNT;
  }

  onChangeReadMore(option: boolean) {
    this.readMoreEnabled = option;
  }
}
